import {Component, OnInit, inject, DestroyRef} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {Tenant, TenantFilter} from 'src/app/models/tenant/tenant';
import {RouterSegments} from 'src/app/models/router-segments';
import {AuthService} from 'src/app/services/auth/auth.service';
import {ActivatedRoute, Router} from '@angular/router';
import {DropdownFilterGroup} from 'src/app/models/filter/dropdown-filter';
import {SidenavService} from 'src/app/services/util/sidenav.service';
import {MatDialog} from '@angular/material/dialog';
import {TenantCostMetric} from 'src/app/models/cost/tenant-cost-metric';
import {CostMgmtService} from 'src/app/services/api/cost-mgmt-service';

@Component({
    selector: 'app-cost-details',
    templateUrl: './cost-details.component.html',
    styleUrls: ['./cost-details.component.scss'],
    standalone: false
})
export class CostDetailsComponent  implements OnInit {
private destroyRef = inject(DestroyRef);
  basepath = RouterSegments.COSTMGMT;
  basetenant: string;
  dataLoaded = false;
  costMetrics: TenantCostMetric[];
  filteredCostMetrics: TenantCostMetric[];
  totalSubscription = 0;
  fullTextSearch: TenantFilter;
  tags: TenantFilter;
  filterGroups: DropdownFilterGroup[];

  constructor(private activatedRoute: ActivatedRoute, private router: Router, private authService: AuthService,
              private costMgmtService: CostMgmtService, private sidenavService: SidenavService, private matDialog: MatDialog) {
  }

  ngOnInit(): void {

    this.basetenant = this.authService.principal.provider;
    console.log(this.basetenant);
    console.log(this.basepath);
    this.loadTenantInfo();

  }

  loadTenantsSearchFilterDetails(fullTextSearch?: string): void {
    if (!fullTextSearch || fullTextSearch.trim().length < 3) {
      fullTextSearch = undefined;
    }
    this.fullTextSearch = {
      fullTextSearch
    };
    this.resetPage();
  }

  resetPage(): void {
    if (this.fullTextSearch.fullTextSearch) {
      this.filteredCostMetrics = this.costMetrics.filter(t =>
        t.tenantId.toLowerCase().match(this.fullTextSearch.fullTextSearch.toLowerCase())
      );
      this.totalSubscription = this.filteredCostMetrics.length;
    } else {
      this.filteredCostMetrics = this.costMetrics;
      this.totalSubscription = this.filteredCostMetrics.length;
    }
  }

  private loadTenantInfo() {
    this.costMgmtService.getTenantsWiseCostMetric().subscribe(costMetrics => {

      this.costMetrics = costMetrics.sort(this.tenantComparator);
      this.dataLoaded = true;
      this.filteredCostMetrics = costMetrics;
      this.totalSubscription = this.costMetrics.length
      // console.table(this.tenants);
    });

  }

  private tenantComparator(fsv: Tenant, ssv: Tenant): number {
    if (fsv.createdDate < ssv.createdDate) {
      return 1;
    } else {
      return -1
    }
  }


}
